import { IS_LOGGED_IN  } from '../actions/authActions';
import { ITEMS_IS_LOADING } from '../actions/commonsActions';

export const isAuth = (state = false, action) => {
	switch (action.type) {
	case IS_LOGGED_IN:
		return action.isAuth;

	default:
		return state;
	}
};

export const itemsIsLoading = (state = false, action) => {
	switch (action.type) {
	case ITEMS_IS_LOADING:
		return action.isLoading;

	default:
		return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/isAuth.js